// Must run before other scripts add submit listeners, so invalid forms are stopped before they see the event (see gulpfile.js)
((window, document) => {
    const urlRegex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})+(?::(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9¡-￿][a-z0-9¡-￿_-]{0,62})?[a-z0-9¡-￿]\.)+(?:[a-z¡-￿]{2,}\.?)|(?:(?:[a-z0-9¡-￿][a-z0-9¡-￿_-]{0,62})?[a-z0-9¡-￿])|(?:(?:[a-z0-9¡-￿][a-z0-9¡-￿_-]{0,62}\.)))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    const v = new aspnetValidation.ValidationService();
    v.ValidationInputCssClassName = 'is-invalid';
    v.ValidationInputValidCssClassName = 'is-valid';
    v.allowHiddenFields = true;
    v.debounce = 0; // only needed for [Remote] validation, which isn't used

    function toggleInputGroupClass(input: HTMLElement, valid: boolean) {
        const inputGroup = input.closest('.input-group');
        inputGroup?.classList.toggle('input-group-valid', valid);
        inputGroup?.classList.toggle('input-group-invalid', !valid);
    }

    const { highlight, unhighlight } = v;

    v.highlight = (input, errorClass, validClass) => {
        highlight.call(v, input, errorClass, validClass);
        toggleInputGroupClass(input, false);
    };

    v.unhighlight = (input, errorClass, validClass) => {
        unhighlight.call(v, input, errorClass, validClass);
        toggleInputGroupClass(input, true);
    };

    // Providers must be added before bootstrap(), the first registered for a name wins
    const mvc = new aspnetValidation.MvcValidationProviders();

    // Tag helpers render some data-val-* attributes without a message, fall back to jQuery Validate's default
    const addProvider = (name: string, provider: import('aspnet-client-validation').ValidationProvider, defaultMessage: string) =>
        v.addProvider(name, (value, element, params) => provider(value, element, params) || element.getAttribute(`data-val-${name}`) || defaultMessage);

    addProvider('required', mvc.required, 'This field is required.');
    addProvider('email', mvc.email, 'Please enter a valid email address.');

    // https://github.com/jquery-validation/jquery-validation/blob/master/src/additional/url2.js
    // Same as url, but TLD is optional
    addProvider('url2', value => !value || urlRegex.test(value), 'Please enter a valid URL.');

    addProvider('wildcarduri', value => !value || urlRegex.test(value.replace(/\*/g, 'x')), 'Please enter a valid wildcard URL.');

    v.bootstrap();

    document.querySelectorAll('form').forEach(form => form.addEventListener('validation', e => {
        if (!(e as CustomEvent<{ valid: boolean }>).detail.valid) {
            form.classList.add('was-validated');
        }
    }));

    window.validationService = v;
})(window, document);
